import React from 'react'

export const Loader = props => {
    return <i className={props.small ? ['fa', 'fa-spinner', 'fa-spin', 'fa-fw'].join(' ') : ['fa', 'fa-spinner', 'fa-spin', 'fa-3x', 'fa-fw'].join(' ')} />
}